import React, { useState } from 'react'
import { NavLink } from "react-router-dom"
import { useSelector, useDispatch } from 'react-redux'
import studygameActions from '../../store/actions/studygameActions'
import gameActions from '../../store/actions/gameActions'
import { logOut } from '../../store/actions/authActions'
import { getOwnUser } from '../../store/actions/apiActions'
import SettingsMenu from '../SettingsMenu'

const loggedInLinks = [
    ['Início', '/dashboard', 'home-32'],
    ['Viajar', '/viajar', 'globe-32'],
    ['Mundo em Notícias', '/mundo-em-noticias', 'news-32'],
    ['Comunidade', '/comunidade', 'community-32'],
]

const LoggedInLinks = () => {
    const dispatch = useDispatch()
    const profile = useSelector(state => state.firebase.profile)

    const [modalIsOpen, setIsOpen] = useState(false);

    const toggleModal = () => {
        setIsOpen(!modalIsOpen);
    }

    const listLink = (destinyName, destiny, icon, itemIndex) => (
        <NavLink activeClassName="navLinkActive" className="navLink" to={destiny} key={itemIndex}
            isActive={(match, location) => {
                if (destinyName === 'Viajar') {
                    return location.pathname.match("/viajar") !== null && true
                } else if (destinyName === 'Comunidade') {
                    return location.pathname.match("/comunidade") !== null && true
                } else {
                    return match && match.isExact && location.pathname.match(destiny) ? true : false
                }
            }}
        >
            <img alt={destinyName} title={destinyName} src={require(`../../assets/icons/32/${icon}.png`)} />
            <span>{destinyName}</span>
        </NavLink>
    )

    return (
        <>
            <div>
                <NavLink
                    exact to={`/comunidade/perfil/${profile.username}`}
                    activeClassName="navLinkActive"
                    className="navLink profile flex-row flex-wrap"
                    onClick={() => dispatch(getOwnUser())}
                >
                    <div className='w-full flex flex-col justify-start pb-2'>
                        <h2 className='pb-0'>{profile.username}</h2>
                        <span className='flex flex-col'>
                            <p className='pb-2'>Nível: {profile.level}</p>

                            <div data-label={`${profile.experiencePercentage}%`} className="progress">
                                <span style={{ width: `${profile.experiencePercentage}%` }} className="value"></span>
                            </div>
                        </span>
                    </div>

                    <div className='w-full flex flex-row pt-6'>
                        <img alt='Perfil' title='Perfil' style={{ marginRight: '15px' }} src={require('../../assets/icons/32/profile-32.png')} />
                        <span>Perfil</span>
                    </div>

                </NavLink>
                {loggedInLinks.map((item, index) => listLink(item[0], item[1], item[2], index))}
            </div>
            <div className='mt-auto'>
                <NavLink activeClassName="navLinkActive" className="navLink" to='/ajuda'
                    isActive={(match, location) => {
                        return match && match.isExact && location.pathname.match('ajuda') ? true : false
                    }}
                >
                    <img alt='Ajuda' title='Ajuda' src={require(`../../assets/icons/32/help-32.png`)} />
                    <span>Ajuda</span>
                </NavLink>
                <button className="navLink" onClick={() => toggleModal()}>
                    <img alt='Configurações' src={require('../../assets/icons/32/settings-32.png')} />
                    <span>Configurações</span>
                </button>
                <NavLink
                    exact to="/"
                    onClick={() => {
                        dispatch(gameActions.quitGame())
                        dispatch(studygameActions.quitGame())
                        dispatch(logOut())
                    }}
                    className="navLink"
                >
                    <img alt='teste' src={require('../../assets/icons/32/logout-32.png')} />
                    <span>Sair</span>
                </NavLink>
                <SettingsMenu openState={modalIsOpen} setOpenState={setIsOpen} />
            </div>
        </>
    )
}

export default LoggedInLinks
